export default [
  "Your password can't be too similar to your other personal information.",
  'Your password must contain at least 8 characters.',
  "Your password can't be a commonly used password.",
  "Your password can't be entirely numeric.",
];
